import { render, staticRenderFns } from "./HighlightBox.vue?vue&type=template&id=e26bba1a&scoped=true"
import script from "./HighlightBox.vue?vue&type=script&lang=js"
export * from "./HighlightBox.vue?vue&type=script&lang=js"
import style0 from "./HighlightBox.vue?vue&type=style&index=0&id=e26bba1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26bba1a",
  null
  
)

export default component.exports